import { clickOnAnswer } from '@wix/bi-logger-customer-care-data/v2';
import {
  ContactSupport as ContactSupportComponent,
  ContactSupportV2 as ContactSupportComponentV2,
  CHATBOT_URL,
  ConsumerSource,
} from '@wix/cc-user-facing-common-components';
import { Box } from '@wix/design-system';
import { useRouter } from 'next/router';
import React, { FunctionComponent, useContext } from 'react';

import { BI } from '../../constants';
import { Context } from '../../context';
import { useBI } from '../../hooks/useBI';
import useIsHelpCenterSearchResultV2Enabled from '../../hooks/useIsHelpCenterSearchResultV2Enabled';
import { useStore } from '../../zustand/stores';

import css from './index.module.scss';

export type ContactSupportProps = {
  searchMethod: string;
};

export { CHATBOT_URL };

export const ContactSupport: FunctionComponent<ContactSupportProps> = ({
  searchMethod,
}) => {
  const searchSessionId = useStore((state) => state.biSlice.searchSessionId);
  const {
    locale,
    query: { term },
  } = useRouter();
  const { sendBIEvent } = useBI();
  const { isMobile } = useContext(Context);
  const isHelpCenterSearchResultV2Enabled =
    useIsHelpCenterSearchResultV2Enabled();
  const onContactSupportClick = async (e: React.MouseEvent<HTMLElement>) => {
    if ((e.target as HTMLAnchorElement).href.startsWith(CHATBOT_URL)) {
      await sendBIEvent(
        clickOnAnswer({
          clicked_item_type: 'summarized_answer_hyperlink',
          summarized_answer_type: 'support request',
          clicked_url: CHATBOT_URL,
          question: term as string,
          search_session_Id: searchSessionId,
          search_method: searchMethod,
          kb_lang: locale,
          source_name: BI.SOURCE_NAMES.SEARCH_RESULTS,
          search_result_selection:
            BI.SEARCH_RESULT_SELECTION.FULL_SEARCH_RESULTS_LIST,
        })
      );
    }
  };

  return isHelpCenterSearchResultV2Enabled ? (
    <Box className={css.contactSupportWrapper}>
      <ContactSupportComponentV2
        isMobile={isMobile}
        locale={locale as string}
        onContactSupportClick={onContactSupportClick}
        chatbotUrl={CHATBOT_URL}
        consumerSource={ConsumerSource.HELP_CENTER}
      />
    </Box>
  ) : (
    <ContactSupportComponent
      locale={locale as string}
      onContactSupportClick={onContactSupportClick}
      chatbotUrl={CHATBOT_URL}
      consumerSource={ConsumerSource.HELP_CENTER}
    />
  );
};
